import { Navigate } from "react-router-dom";

export default function UserPageEventAdmin() {
  return <Navigate to="/user/events" replace />;
}
